module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/bed-e6ab3195b743266b011bb899b34c3239.svg";